import type { AppReview as AppReviewType } from 'types/capi/modules';

import AppleIcon from '~/assets/icons/Apple';
import StarEmpty from '~/assets/icons/StarEmpty';
import StarFull from '~/assets/icons/StarFull';
import DownloadAppBlock from '~/components/DownloadAppBlock';

function Reviews({ items }: { items: AppReviewType[] }) {
  return (
    <div className="no-scrollbar flex overflow-x-scroll max-md:-mx-4 max-md:px-4 md:flex md:w-full">
      <div className="no-scrollbar flex shrink-0 gap-2 overflow-x-scroll md:w-full md:gap-6">
        {items.map((item, index) => (
          <AppReview key={`app-review-${index}`} review={item} />
        ))}
      </div>
    </div>
  );
}

type AppReviewProps = {
  review: AppReviewType;
};

function AppReview({ review }: AppReviewProps) {
  return (
    <div className="flex size-[240px] flex-col gap-4 rounded-lg bg-black p-4 md:min-w-[264px] md:py-6">
      <div className="flex flex-col gap-2">
        <h2 className="text-sm font-semibold text-white">{review.title}</h2>
        <div className="flex flex-row items-center justify-between">
          <Rating height="16" rating={review.rating} width="16" />
          <p className="items-center text-sm text-grey-hide">{review.date}</p>
        </div>
      </div>
      <div className="flex">
        <p className="text-start text-sm text-white">{review.text}</p>
      </div>
    </div>
  );
}

type RatingProps = {
  height?: string;
  rating: number;
  width?: string;
};

function Rating({ rating, height = '16', width = '16' }: RatingProps) {
  const key = Math.random();
  const dimensions = { height, width };

  return (
    <div className="mt-0.5 flex items-center">
      {Array.from({ length: 5 }).map((_, i) =>
        rating >= i + 1 ? (
          <StarFull fill="#FA0" key={`star-full-${key}-${i}`} {...dimensions} />
        ) : (
          <StarEmpty
            stroke="#FA0"
            key={`star-empty-${key}-${i}`}
            {...dimensions}
          />
        )
      )}
    </div>
  );
}

export default function AppBanner({ items }: { items: AppReviewType[] }) {
  return (
    <>
      <DownloadAppBlock
        downloadLink="https://thesolesupplier.onelink.me/BPkz/8481irlk"
        qrCode="https://cms-cdn.thesolesupplier.co.uk/bolt/assets/images/download_app_homepage_qr_code.png"
        pagePosition="Homepage App Banner"
      />
      <section className="bg-dark-background px-4 md:px-8">
        <div className="mx-auto flex max-w-desktop flex-col gap-6 bg-dark-background py-8 lg:py-16 ">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
            <p className="text-start text-[32px] text-white md:text-[40px]">
              Recent App Store reviews from our users
            </p>
            <div className="flex flex-row items-end gap-2">
              <div className="flex md:hidden">
                <AppleIcon colour="white" height="22" width="22" />
              </div>
              <div className="flex">
                <Rating
                  height="22"
                  rating={5}
                  width="22"
                  key="app-banner-rating"
                />
              </div>
              <p className="text-sm text-white">4.8</p>
            </div>
          </div>
          <Reviews items={items} />
        </div>
      </section>
    </>
  );
}
